import { render } from "./Button.vue?vue&type=template&id=f567935c&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=f567935c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f567935c"

export default script